<template lang="pug">
.page.d-flex
  nav-header
  v-row(justify="center").pt-16
    v-col(cols="12" sm="10" md="8" lg="6" xl="4").pt-16
      v-row(justify="center").pt-16
        v-col(cols="12").mb-12
          h1.text-h1.text-center.text-uppercase.font-weight-bold FAQ
        v-col(cols="12")
          v-expansion-panels(:flat="true" v-model="open_question")
            v-expansion-panel(v-for="(item, i) in content.items" :key="i" :id="item.link")
              v-expansion-panel-header
                h4.text-h4.font-weight-bold  {{ item.q }}
              v-expansion-panel-content
                span(v-html="item.a")
</template>

<script>
import { findIndex } from 'lodash'
import NavHeader from '~/components/NavHeader.vue'

export default {
  components: { NavHeader },
  head () {
    return this.$seo({
      title: 'Frequently Asked Questions'
    })
  },
  data () {
    return {
      open_question: -1
    }
  },
  async asyncData ({ $content, params, route }) {
    const content = await $content('faq').fetch()
    let index = -1

    if (route.hash) {
      index = findIndex(content.items, ['link', route.hash.substring(1)])
    }

    return { content, open_question: index }
  }
}
</script>
